import { Directive, HostListener } from '@angular/core';

import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { MatStepper } from '@angular/material/stepper';

@Directive({
    selector: '[ebbStepperScroller]',
    standalone: false
})
export class MatStepperScrollerDirective {
  constructor(private stepper: MatStepper) {}

  @HostListener('selectionChange', ['$event'])
  selectionChanged(selection: StepperSelectionEvent) {
    const stepElement = document.getElementById('ebb-stepper-scroller-top');
    if (stepElement) {
      if(this.detectIE11()){
        //IE11 has issues with scrollIntoView and will scroll html element horizontally
        window.scrollTo(0, stepElement.offsetTop);
      } else {
        setTimeout(() => {
          stepElement.scrollIntoView({
            block: 'start',
            inline: 'nearest',
            behavior: 'smooth'
          });
        }, 250);
      }
    }
  }

  private detectIE11() {
    return window.navigator.userAgent.indexOf('Trident/') > 0;
  }
}